import React, { CSSProperties } from 'react';
import { Grid, SxProps, Typography } from '@mui/material';
import { styles } from './empty-state-container-helper';

export interface EmptyStateContainerProps {
    emptyStateIcon: string;
    emptyStateHeading?: string;
    emptyStateBodyMessage?: React.ReactNode;
    customEmptyStateContainerStyles?: SxProps;
    customImageStyles?: CSSProperties;
    customHeadingContainerStyles?: SxProps;
    customHeadingTextStyles?: SxProps;
}

export const EmptyStateContainer = ({
    emptyStateIcon,
    emptyStateHeading,
    emptyStateBodyMessage,
    customEmptyStateContainerStyles,
    customHeadingContainerStyles,
    customHeadingTextStyles,
    customImageStyles,
}: EmptyStateContainerProps): React.JSX.Element => {
    return (
        <Grid
            sx={customEmptyStateContainerStyles ?? styles.emptyStateContainer}
        >
            <Grid>
                <img
                    style={customImageStyles}
                    src={emptyStateIcon}
                    alt='Empty_State_Image'
                />
            </Grid>
            <Grid
                sx={
                    customHeadingContainerStyles ?? styles.emptyHeadingContainer
                }
            >
                <Typography
                    sx={customHeadingTextStyles ?? styles.emptyHeadingText}
                >
                    {emptyStateHeading ?? 'Nothing to see here.'}
                </Typography>
            </Grid>
            {emptyStateBodyMessage && (
                <Grid sx={styles.emptySubHeadingContainer}>
                    <Typography sx={styles.emptySubHeadingText}>
                        {emptyStateBodyMessage}
                    </Typography>
                </Grid>
            )}
        </Grid>
    );
};
